// extracted by mini-css-extract-plugin
export default {"input":"SearchInput_input__mhNxk","inputDisabled":"SearchInput_inputDisabled__v7JwN"};